module.exports = __webpack_public_path__ + "static/media/loginTTP.6404036f.svg";